module.exports = __webpack_public_path__ + "static/media/spansberry.87963a59.png";